export const ID_TOKEN_KEY = "id_token";
export const SMS_TOKEN_KEY = "sms_token";

export const getToken = (key) => {
  return window.localStorage.getItem(key);
};

export const saveToken = (key,token) => {
  window.localStorage.setItem(key, token);
};

export const destroyToken = (key) => {
  window.localStorage.removeItem(key);
};

export default { getToken, saveToken, destroyToken, ID_TOKEN_KEY, SMS_TOKEN_KEY };
